import React, { useState, useEffect, useContext } from "react";
import { IoIosHeartEmpty } from "react-icons/io";
import { IoHeartSharp, IoHeartDislikeOutline } from "react-icons/io5";
////import { toast } from "react-hot-toast";
//import { fetchWishlistCount, fetchCartCount } from "#common/fetchCartCount";
import { useCount } from "../../context/CountContext";
import useWishlistHandler from "../../utils/HandleWishlist";
import AuthContext from '../../context/AuthContext';
import { useAuth } from "../../context/AuthContext";
import { StyleGetCartCount, TransferBasket } from "../../api/styleJewelleryService";

const WishListIcon = ({
    fill = "#0f4c81",
    size,
    Stock_ID,
    WishlistBasket_ID,
    Quantity = 1,
    Rate = 0,
    Amount = 0,
    GoldColor_ID = 0,
    GoldQuality_ID = 0,
    GoldWeight = 0,
    Clarity_ID = 0,
    DiamondCategory_ID = 0,
    ProductSize_ID = 0,
    fetchData,
    iswishlist: initialIsWishlist = "NO",
    onUpdateWishlistBasketID,
    onTransfer,
    onRecentViewUpdate,
    fromPage,
    Style_ID,
    JewelCode,
    StyleNo,
    Cart_ID,
    isincart,
    ActualCart_ID,
    isProcessing: propIsProcessing,
    setIsProcessing: propSetIsProcessing,
}) => {
    const { user, showToast } = useContext(AuthContext);

    const [localIsProcessing, setLocalIsProcessing] = useState(false);
    const isProcessing = propIsProcessing !== undefined ? propIsProcessing : localIsProcessing;
    const setIsProcessing = propSetIsProcessing || setLocalIsProcessing;

    const isLoggedIn = user?.isAuthenticated;
    const { fetchWishlistCount, fetchStyleCartCount, setCartCount } = useCount();
    const [IS_AddedInWishlist, setIsWishlist] = useState("NO");
    const { HandleWishListInsert, HandleWishListRemove } = useWishlistHandler();
    const [currentBasketID, setCurrentBasketID] = useState(Cart_ID || WishlistBasket_ID);
    useEffect(() => {
        const isTrue = (val) => ["YES", "TRUE", "1", "Y"].includes(String(val ?? "").toUpperCase()) || val === 1 || val === true;
        const status = isTrue(initialIsWishlist) ? "YES" : "NO";
        setIsWishlist(status);

        const basketID = Cart_ID || WishlistBasket_ID;
        setCurrentBasketID(basketID);
    }, [initialIsWishlist, Cart_ID, WishlistBasket_ID]);

    const getStringValue = (value) => {
        if (value === null || value === undefined) return "0";
        return String(value);
    };

    const handleBasketInsert = async () => {
        if (isProcessing) return;
        setIsProcessing(true);
        const { success, message, titleMessage, type, newBasketID } = await HandleWishListInsert({
            Party_ID: user?.SelectedCustomer_ID,
            Style_ID: getStringValue(Style_ID),
            JewelCode: getStringValue(JewelCode),
            StyleNo: getStringValue(StyleNo),
            Quantity: getStringValue(Quantity),
        });

        if (success) {
            setIsWishlist("YES");
            setCurrentBasketID(newBasketID);
            onUpdateWishlistBasketID?.(Style_ID, newBasketID, true);
            onRecentViewUpdate?.(Style_ID, newBasketID);
            fetchWishlistCount?.(user?.SelectedCustomer_ID);
            showToast({
                title: titleMessage || "Success",
                message: message || "Item added to Wishlist.",
                type: "success"
            });
        } else {
            showToast({
                title: "Error",
                message: message || "Failed to add item to Wishlist.",
                type: type || "error",
            });
        }
        setIsProcessing(false);
    };

    const handleBasketRemove = async () => {
        if (isProcessing) return;
        setIsProcessing(true);
        const { success, message, titleMessage, type } = await HandleWishListRemove({
            Cart_ID: getStringValue(currentBasketID),
            Style_ID: getStringValue(Style_ID),
        });
        if (success) {
            if (!fromPage) setIsWishlist("NO");
            setCurrentBasketID(null);
            onUpdateWishlistBasketID?.(Style_ID, null);
            onRecentViewUpdate?.(Style_ID, null);
            fetchWishlistCount(user?.SelectedCustomer_ID);
            showToast({
                title: titleMessage || "Removed",
                message: message || "Item removed from Wishlist.",
                type: "success"
            });
        } else {
            showToast({
                title: "Error",
                message: message || "Failed to remove item from Wishlist.",
                type: type || "error",
            });
        }
        setIsProcessing(false);
    };

    //const handleWishlistToggle = () => {
    //    IS_AddedInWishlist === "NO" ? handleBasketInsert() : handleBasketRemove();
    //};

    //const handleWishlistToggle = async () => {
    //    const isTrue = (val) => ["YES", "TRUE", "1", "Y"].includes(String(val ?? "").toUpperCase());

    //    if (isTrue(IS_AddedInWishlist)) {
    //        await handleBasketRemove();
    //        return;
    //    }

    //    await handleBasketInsert();
    //};

    const handleWishlistToggle = async () => {
        if (!isLoggedIn) {
            showToast({
                title: "Validation",
                message: "Please log in to manage your Wishlist.",
                type: "warning",
            });
            return;
        }

        if (!user?.SelectedCustomer_ID || user?.SelectedCustomer_ID === 0) {
            showToast({
                title: "Validation",
                message: "Please select a specific customer to manage Wishlist.",
                type: "warning",
            });
            return;
        }
        if (isProcessing) return;
        setIsProcessing(true);

        const isTrue = (val) => ["YES", "TRUE", "1", "Y"].includes(String(val ?? "").toUpperCase());

        if (isTrue(IS_AddedInWishlist)) {
            setIsProcessing(false); // Reset to allow handleBasketRemove to set its own
            await handleBasketRemove();
            return;
        }

        const isInCart = isTrue(isincart) && (ActualCart_ID && ActualCart_ID !== "0" && ActualCart_ID !== 0);

        try {
            if (isInCart) {
                const response = await TransferBasket({
                    Party_ID: user?.SelectedCustomer_ID,
                    Style_ID: getStringValue(Style_ID)
                });

                if (response?.Message?.[0]?.RETURNCODE === "1") {
                    const { RETURNMESSAGE, RETURNMESSAGETITLE } = response.Message[0];
                    const transferID = response.InsertWishlist?.at(-1)?.Basket_ID;
                    setCurrentBasketID(transferID);
                    setIsWishlist("YES");
                    fetchStyleCartCount(user?.SelectedCustomer_ID);
                    fetchWishlistCount(user?.SelectedCustomer_ID);
                    onTransfer?.(Style_ID, transferID, 'wishlist');
                    showToast({
                        title: RETURNMESSAGETITLE || "Success",
                        message: RETURNMESSAGE || "Item transferred to Wishlist.",
                        type: "success"
                    });
                } else {
                    throw new Error(response?.Message?.[0]?.RETURNMESSAGE || "Transfer failed");
                }
            } else {
                setIsProcessing(false); // Reset to allow handleBasketInsert to set its own
                await handleBasketInsert();
            }
        } catch (error) {
            console.error("Wishlist action error:", error);
            showToast({
                title: "Error",
                message: error.message || "An error occurred.",
                type: "error",
            });
        } finally {
            setIsProcessing(false);
        }
    };


    return (
        <div className="wishlist_icon">
            <button
                className={`wishlist_heart ${IS_AddedInWishlist === "YES" ? "beat_on" : "beat_off"}`}
                disabled={isProcessing}
                style={{ opacity: isProcessing ? 0.6 : 1, cursor: isProcessing ? 'not-allowed' : 'pointer' }}
                onClick={(e) => {
                    e.stopPropagation();
                    handleWishlistToggle();
                }}
            >
                {IS_AddedInWishlist === "YES" ? (
                    <IoHeartSharp fill={fill} size={size} />
                ) : (
                    <IoIosHeartEmpty fill={fill} size={size} />
                )}
            </button>
        </div>
    );
};

export default WishListIcon;